import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "../assets/css/style.css";
import DanLogo from "../assets/img/dan-logo.svg";
import DoneCashback from "../assets/img/DONE-Cashback-System.svg";

function DanAppStart() {
  const navigate = useNavigate(); 

  useEffect(() => {
    const donetoken = localStorage.getItem("donetoken");
    if (donetoken) {
      navigate("/panel/home"); // اگر توکن وجود دارد، وارد پنل شود
    }
  }, [navigate]);



  return (
    <div className="bg-33 start-bdy">
      {/* لوگو */}
      <div className="logomotion">
        <div className="start-logo">
          <img src={DanLogo} alt="Dan Logo" />
          <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
        </div>
      </div>

      {/* دکمه‌های ورود و ثبت‌نام */}
      <div className="loginbtns">
        <div className="btndiv-1">
          <button
            className="loginbtn-1"
            onClick={() => navigate("/login")} 
          >
            ورود به حساب کاربری
          </button>
          <button
            className="regbtn-1"
            onClick={() => navigate("/register")} 
          >
            ایجاد حساب کاربری
          </button>
        </div>
      </div>
    </div>
  );
}

export default DanAppStart;
